module.exports = __webpack_public_path__ + "static/media/aboutIcon.a2b1dcb8.svg";